"use strict";

exports.__esModule = true;
exports.default = void 0;
var _Symbol2 = _interopRequireDefault(require("./_Symbol.js"));
var _arrayMap = _interopRequireDefault(require("./_arrayMap.js"));
var _isArray = _interopRequireDefault(require("./isArray.js"));
var _isSymbol = _interopRequireDefault(require("./isSymbol.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol2.default ? _Symbol2.default.prototype : undefined,
  symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if ((0, _isArray.default)(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return (0, _arrayMap.default)(value, baseToString) + '';
  }
  if ((0, _isSymbol.default)(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
var _default = exports.default = baseToString;